import { createSelector } from 'reselect';
import { getCurrentCompanyId } from './companySelectors';

const sessionSelector = (state) => state.session;

export const getCurrentUser = createSelector(
    sessionSelector,
    (session) => session.user
);

export const getUserRole = createSelector(
    getCurrentUser,
    getCurrentCompanyId,
    (user, companyId) => user.companies && companyId ? (user.companies[companyId].isAdmin ? 'Admin' : 'Member') : 'Member'
);

export const isUserAdmin = createSelector(
    getCurrentUser,
    getCurrentCompanyId,
    (user, companyId) => user.companies && companyId ? (user.companies[companyId].isAdmin) : false
);



// WEBPACK FOOTER //
// ./src/containers/selectors/userSelectors.js